// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"142":"2f16dbca","722":"ab796482","875":"7b480951"}[chunkId] + ".chunk.css";
};